import React from 'react'
import {
  TheContent,
  TheSidebar,
  TheFooter,
  TheHeader,
  TheHeaderNew
} from './index'



const TheLayout = () => {

  return (
    <div className="c-app c-default-layout" >
      <div style={{display:'none'}}>

      <TheSidebar />
      </div>
      <div >

        <TheHeader />
        <div style={{paddingLeft:40}}>
          <TheContent />
        </div>
        <TheFooter />
      </div>
    </div>
  )
}

export default TheLayout
